import { render, staticRenderFns } from "./ArrivalNoticeView.vue?vue&type=template&id=6f408592&"
import script from "./ArrivalNoticeView.vue?vue&type=script&lang=ts&"
export * from "./ArrivalNoticeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports